var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.175 4.16667C18.175 2.90101 17.149 1.875 15.8833 1.875H4.21665C2.951 1.875 1.92499 2.90101 1.92499 4.16667V8.33333C1.92499 8.67851 2.20481 8.95833 2.54999 8.95833C2.89517 8.95833 3.17499 8.67851 3.17499 8.33333V4.16667C3.17499 3.59137 3.64136 3.125 4.21665 3.125H15.8833C16.4586 3.125 16.925 3.59137 16.925 4.16667V15.8333C16.925 16.4086 16.4586 16.875 15.8833 16.875H11.35C11.0049 16.875 10.725 17.1548 10.725 17.5C10.725 17.8452 11.0049 18.125 11.35 18.125H15.8833C17.149 18.125 18.175 17.099 18.175 15.8333V4.16667Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.30835 15C0.30835 12.3631 2.46317 10.2083 5.10002 10.2083C7.73686 10.2083 9.89168 12.3631 9.89168 15C9.89168 17.6368 7.73686 19.7916 5.10002 19.7916C2.41743 19.7916 0.30835 17.6327 0.30835 15ZM5.10002 11.4583C3.15353 11.4583 1.55835 13.0535 1.55835 15C1.55835 16.9506 3.11593 18.5416 5.10002 18.5416C7.0465 18.5416 8.64168 16.9465 8.64168 15C8.64168 13.0535 7.0465 11.4583 5.10002 11.4583ZM4.68335 12.0833C5.02853 12.0833 5.30835 12.3631 5.30835 12.7083V14.5833C5.30835 14.6548 5.36186 14.7083 5.43335 14.7083H6.93335C7.27853 14.7083 7.55835 14.9881 7.55835 15.3333C7.55835 15.6785 7.27853 15.9583 6.93335 15.9583H5.43335C4.6715 15.9583 4.05835 15.3452 4.05835 14.5833V12.7083C4.05835 12.3631 4.33817 12.0833 4.68335 12.0833Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8917 14.5581C14.8917 14.2129 14.6119 13.9331 14.2667 13.9331H12.1834C11.8382 13.9331 11.5584 14.2129 11.5584 14.5581C11.5584 14.9033 11.8382 15.1831 12.1834 15.1831H14.2667C14.6119 15.1831 14.8917 14.9033 14.8917 14.5581Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8917 5.80811C14.8917 5.46293 14.6119 5.18311 14.2667 5.18311H5.93337C5.58819 5.18311 5.30837 5.46293 5.30837 5.80811C5.30837 6.15328 5.58819 6.43311 5.93337 6.43311H14.2667C14.6119 6.43311 14.8917 6.15328 14.8917 5.80811Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8917 8.72477C14.8917 8.37959 14.6119 8.09977 14.2667 8.09977H8.43337C8.08819 8.09977 7.80837 8.37959 7.80837 8.72477C7.80837 9.06995 8.08819 9.34977 8.43337 9.34977H14.2667C14.6119 9.34977 14.8917 9.06995 14.8917 8.72477Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8917 11.6414C14.8917 11.2963 14.6119 11.0164 14.2667 11.0164H11.35C11.0049 11.0164 10.725 11.2963 10.725 11.6414C10.725 11.9866 11.0049 12.2664 11.35 12.2664H14.2667C14.6119 12.2664 14.8917 11.9866 14.8917 11.6414Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationsIcon);
export default __webpack_public_path__ + "static/media/quotations_icon.9ed725d91663993f97f4a8adb44ea721.svg";
export { ForwardRef as ReactComponent };